// 상단 필터 문장
import { useTranslation } from "react-i18next";
import styles from "../IntegratedSearchPage.module.css";
import { labelFor, FILTER_GROUPS } from "../data/searchData";
import { Icon } from "./Icons";

/* 필터 키 → 라벨(번역키). 정본은 FILTER_GROUPS 라 거기서 뽑아 쓴다.
 * 두 곳에 따로 적어두면 이름을 바꿀 때 한쪽만 바뀐다. */
const FIELD_LABELS = (() => {
    const m = {};
    FILTER_GROUPS.forEach((g) => g.fields.forEach((f) => { m[f.key] = f.label; }));
    return m;
})();

export function QuerySentence({ chips, toggleChip, totalSamples, selectedDrug, mutState, cycleMutation }) {
    const { t } = useTranslation();
    const LABELS = FIELD_LABELS;
    const parts = Object.entries(chips).filter(([, vs]) => vs?.length);
    const incGenes = Object.keys(mutState).filter((g) => mutState[g] === "include");
    const excGenes = Object.keys(mutState).filter((g) => mutState[g] === "exclude");
    const hasAny = parts.length || incGenes.length || excGenes.length;

    return (
        <div className={styles.querySentence}>
            <span className={styles.queryPrefix}>{t('조건')}</span>
            {!hasAny && <span className={styles.queryEmpty}>{t('적용한 필터 없음')} — {totalSamples}</span>}

            {parts.map(([k, vs], i) => (
                <span key={k} className={styles.queryPart}>
                    {i > 0 && <span className={styles.queryJoin}>·</span>}
                    <span className={styles.queryKey}>{t(LABELS[k] || k)}</span>
                    <span className={styles.queryValues}>
                        {vs.map((v) => (
                            <span key={v} className={styles.queryToken}>
                                {t(labelFor(v))}
                                <button type="button" onClick={() => toggleChip(k, v)}
                                    className={styles.queryTokenX} aria-label={t(labelFor(v))}><Icon.X /></button>
                            </span>
                        ))}
                    </span>
                </span>
            ))}

            {incGenes.length > 0 && (
                <span className={styles.queryPart}>
                    {(parts.length > 0) && <span className={styles.queryJoin}>·</span>}
                    <span className={styles.queryKey}>Mutation</span>
                    <span className={styles.queryJoin}>{t('포함')}</span>
                    <span className={styles.queryValues}>
                        {incGenes.map((g) => (
                            <span key={g} className={styles.queryToken}>{g}
                                <button type="button" onClick={() => cycleMutation(g)} className={styles.queryTokenX}><Icon.X /></button>
                            </span>
                        ))}
                    </span>
                </span>
            )}
            {excGenes.length > 0 && (
                <span className={styles.queryPart}>
                    {(parts.length > 0 || incGenes.length > 0) && <span className={styles.queryJoin}>·</span>}
                    <span className={styles.queryKey}>Mutation</span>
                    <span className={styles.queryJoin}>{t('제외')}</span>
                    <span className={styles.queryValues}>
                        {excGenes.map((g) => (
                            <span key={g} className={`${styles.queryToken} ${styles.queryTokenNot}`}>{g}
                                <button type="button" onClick={() => cycleMutation(g)} className={styles.queryTokenX}><Icon.X /></button>
                            </span>
                        ))}
                    </span>
                </span>
            )}

            {selectedDrug && <span className={styles.queryDrugTag}><Icon.Pill /> IC50: {selectedDrug}</span>}
        </div>
    );
}

/* =============================================================
 * 결과 테이블 — 오가노이드 병합 + NGS 그룹 행 + 약물 IC50
 *   (Patient / Mapping rate / Columns 버튼 제거)
 * ============================================================= */